import { feedbackApi } from "../store/api/feedbackApi";
import { runMutation } from "../store/api/runtime";

export async function submitFeedback(payload: Record<string, unknown>): Promise<unknown> {
  return runMutation(feedbackApi.endpoints.submitFeedback.initiate, payload);
}
